<div class="navigation">
  <ul>
    <li (click)="setDestinationPage(); order.newInvoice(); order.setInvoiceHasFactorAndHasPaymentLink()">
      <i class="new-factor icon-add-o"></i>
    </li>
    <li
      (click)="order.setActivePage(order.activePageEnum.Salon)"
      *ngIf="order.currentSaleMethodNature !== order.SaleMethodNature.Delivery"
      [class.active]="order.currentActivePage === order.activePageEnum.Salon">
      <i class="icon-table"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Footer.Table" | translate }}</span>
    </li>
    <li (click)="order.setActivePage(order.activePageEnum.Customer)" [class.active]="order.currentActivePage === order.activePageEnum.Customer">
      <i class="icon-people-o"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Footer.Customer" | translate }}</span>
    </li>
    <li (click)="order.setActivePage(order.activePageEnum.OrderItem)" [class.active]="order.currentActivePage === order.activePageEnum.OrderItem">
      <i class="icon-assignment-o"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Footer.Order" | translate }}</span>
    </li>
    <li (click)="order.setActivePage(order.activePageEnum.Invoice)" [class.active]="order.currentActivePage === order.activePageEnum.Invoice">
      <i class="icon-receipt_long-F"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Footer.Basket" | translate }}</span>
    </li>
    <li (click)="order.setActivePage(order.activePageEnum.Invoices)" [class.active]="order.currentActivePage === order.activePageEnum.Invoices">
      <i class="icon-library_books-o"></i>
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Footer.Invoices" | translate }}</span>
    </li>
    <li class="mobile-fast-access" (click)="showFastAccess($event)">
      <i class="icon-sort-o"></i>
    </li>
  </ul>
</div>
